import { Component, input, output } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Component({
  selector: 'kl-tree',
  standalone: false,
  templateUrl: './kl-tree.html',
  styleUrl: './kl-tree.scss',
})
export class KlTreeComponent {
  readonly value = input<TreeNode[]>([]);
  readonly selectionMode = input<'single' | 'multiple' | 'checkbox'>('single');
  readonly selection = input<TreeNode | TreeNode[] | null>(null);
  readonly propagateSelectionUp = input(true);
  readonly propagateSelectionDown = input(true);
  readonly scrollHeight = input('400px');
  readonly filter = input(false);
  readonly filterMode = input<'lenient' | 'strict'>('lenient');
  readonly filterPlaceholder = input('');

  readonly selectionChange = output<TreeNode | TreeNode[] | null | undefined>();

  onSelectionChange(value: TreeNode | TreeNode[] | null | undefined): void {
    this.selectionChange.emit(value);
  }
}
